import { useQuery } from "@tanstack/react-query";

import { RoadieShipment } from "@web-app/types";
import http from "@web-app/utils/http";

export const useRoadie = (entity: string, id: string) => {
  const get = async () => {
    return http
      .get<RoadieShipment[]>(`/integrations/roadie/${entity}/${id}/shipments`)
      .then((response) => response.data)
      .catch(() => {
        return null;
      });
  };

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryFn: get,
    queryKey: ["roadie-get-shipments", entity, id],
  });

  return {
    data,
    isLoading,
    isRefetching,
    refetch,
  };
};
